import { useId } from "react";

export function LogoMark({ className = "h-8 w-8" }) {
  const uid = useId().replace(/:/g, "");
  const tile = `tile-${uid}`;
  const gold = `gold-${uid}`;
  const glow = `glow-${uid}`;
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={tile} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#241C33" /><stop offset="1" stopColor="#120E1B" />
        </linearGradient>
        <linearGradient id={gold} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#F3C869" /><stop offset="1" stopColor="#D08F1F" />
        </linearGradient>
        <radialGradient id={glow} cx="0.5" cy="0.5" r="0.5">
          <stop offset="0" stopColor="#E8A93D" stopOpacity="0.55" /><stop offset="1" stopColor="#E8A93D" stopOpacity="0" />
        </radialGradient>
      </defs>
      <rect width="64" height="64" rx="14" fill={`url(#${tile})`} />
      <circle cx="40" cy="20" r="14" fill={`url(#${glow})`} />
      <path d="M13 37Q29 19 47 14" fill="none" stroke="#F4EFE8" strokeWidth="1.6" strokeLinecap="round" opacity="0.5" />
      <circle cx="18" cy="34" r="2.4" fill={`url(#${gold})`} />
      <circle cx="30" cy="26.5" r="3" fill={`url(#${gold})`} />
      <circle cx="44" cy="16.5" r="3.8" fill={`url(#${gold})`} />
      <circle cx="43" cy="15.3" r="1.1" fill="#F7D689" />
      <path d="M10 47c5.5-7 11.5-7 17 0s11.5 7 17 0" fill="none" stroke="#F4EFE8" strokeWidth="4" strokeLinecap="round" />
      <path d="M18 57c4-5 8.5-5 12.5 0" fill="none" stroke="#F4EFE8" strokeWidth="3" strokeLinecap="round" opacity="0.5" />
      <circle cx="54" cy="11" r="1.3" fill="#E8A93D" opacity="0.85" />
    </svg>
  );
}

export function Logo() {
  return (
    <span className="flex items-center gap-2.5">
      <LogoMark />
      <span className="font-display text-2xl font-semibold tracking-tight">Melic</span>
    </span>
  );
}
